document.addEventListener("DOMContentLoaded", function () {
  const submitBtn = document.getElementById("outpost-submit");
  const formContainer = document.getElementById("outpost-form");
  const messageDiv = document.getElementById("form-success-message");
  const loadingIndicator = document.getElementById("form-loading");

  const endpoint = "https://script.google.com/macros/s/AKfycbzJRA0muQPbH5RsAH8gxsIMZuLJVDE4u768HPP2JC0_yLwflu6m4XNaHwYM_2jXWzmN/exec";

  if (!submitBtn || !formContainer) return;

  submitBtn.addEventListener("click", function () {
    const formData = new FormData();
    let valid = true;

    // Show loading state
    loadingIndicator.style.display = "block";
    submitBtn.disabled = true;

    // Required fields
    const requiredFields = [
      "full_name",
      "email",
      "phone",
      "dob_year",
      "dob_month",
      "dob_day",
      "address",
    ];

const termsCheckbox = formContainer.querySelector("#terms");
if (!termsCheckbox?.checked) {
  alert("You must agree to the Terms and Conditions before submitting.");
  valid = false;
}

    
    requiredFields.forEach((fieldName) => {
      const input = formContainer.querySelector(`[name="${fieldName}"]`);
      if (!input || !input.value.trim()) {
        input?.classList.add("invalid");
        valid = false;
      } else {
        input.classList.remove("invalid");
        formData.append(fieldName, input.value);
      }
    });

    // Optional fields
    const optionalFields = ["bank_account", "bank_routing"];
    optionalFields.forEach((fieldName) => {
      const input = formContainer.querySelector(`[name="${fieldName}"]`);
      if (input && input.value) {
        formData.append(fieldName, input.value);
      }
    });

    // Membership level
    const membership = document.getElementById("selected-membership");
    if (!membership.value) {
      alert("Please select a membership level.");
      loadingIndicator.style.display = "none";
      submitBtn.disabled = false;
      valid = false;
    } else {
      formData.append("membership", membership.value);
    }

    if (!valid) {
      alert("Please fill out all required fields.");
      loadingIndicator.style.display = "none";
      submitBtn.disabled = false;
      return;
    }

    fetch(endpoint, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        loadingIndicator.style.display = "none";
        submitBtn.disabled = false;

        if (response.ok) {
          messageDiv.style.display = "block";
          formContainer.reset?.();
          document
            .querySelectorAll(".membership-card")
            .forEach((c) => c.classList.remove("selected"));
          membership.value = "";

          setTimeout(() => {
            window.location.reload();
          }, 4000);
        } else {
          alert("Oops! Something went wrong.");
        }
      })
      .catch((error) => {
        loadingIndicator.style.display = "none";
        submitBtn.disabled = false;

        console.error("Submission error:", error);
        alert("An error occurred. Please try again later.");
      });
  });

  // Membership card selection
  const cards = document.querySelectorAll(".membership-card");
  const membershipInput = document.getElementById("selected-membership");

  cards.forEach((card) => {
    card.addEventListener("click", () => {
      cards.forEach((c) => c.classList.remove("selected"));
      card.classList.add("selected");
      membershipInput.value = card.dataset.value;
    });
  });

    const toggleBtn = document.getElementById("toggle-terms");
  const termsContent = document.getElementById("terms-content");

  if (toggleBtn && termsContent) {
    toggleBtn.addEventListener("click", () => {
      const isVisible = termsContent.style.display === "block";
      termsContent.style.display = isVisible ? "none" : "block";
      toggleBtn.textContent = isVisible ? "+ View Terms & Conditions" : "– Hide Terms & Conditions";
    });
  }

});
